import React from 'react'
import * as DataUtil from '../util/DataUtil'
import * as Util from '../util/Util'
import About from './About'
//import {PrivacyTerms} from './About'

export default class Privacy extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {
    const filePath = `/md/privacy.md`
    DataUtil.fetchText(filePath, (text)=>{
      const template = text
      if (typeof(template)==='string'&&template.length>0) {
        const content = Util.fromTemplate(template)(About)
        if (typeof(content)==='string'&&content.length>0) {
          this.setState({content})
        }
      }
    })
  }
  render() {
    const {content} = this.state
    return (
      <div className="main-content">
        {
          typeof(content)==='string'&&content.length>0&&
          <div dangerouslySetInnerHTML={Util.fromMd(this.state.content)}
          />
        }
      </div>
    )
  }
}
